<div class="card card-statistics mb-30">
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-6">
        <button  *ngIf="!InProccessing" type="button" (click)="OnSubmit()" class="btn btn-success" style="margin-right: 5px;"><i
            class="fa  fa-plus-circle"></i> Save </button>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
    </div>

    <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Question</th>
              <th>Answer</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Evaluate">
             <td>{{DataList_Evaluate.indexOf(item)+1}}</td>
             <td>{{item.title}}</td>
             <td>
                <div *ngIf="item.type==1">
                  <select class="custom-select"  [(ngModel)]="item.dsc">
                    <option *ngFor="let itemDetail of item.option" [value]="itemDetail">{{itemDetail}}</option>
                  </select>
                </div>

                <div *ngIf="item.type==2">
                  <input type="text" [(ngModel)]="item.dsc"/>
                </div>

             </td>
            </tr>
          </tbody>
        </table>
    </div>

  </div>
</div>
